export * from './viewerManagerStructureApi'
export * from './beckyPropsInitialStore'
export * from './platform'
export * from './renderDone'

export const CarmiInstance = Symbol('CarmiInstance')
